import ShowPopup from './popups/Show.jsx'
import DeletePopup from './popups/Delete.jsx'

export default function Visitor({ visitorItem }) {
    const hasBadges = visitorItem.visitor_is_minor || visitorItem.person_is_guardian || visitorItem.person_will_invite_others || visitorItem.person_is_visitor;

    return (
        <li className="visitor-item">
            <ShowPopup
                item={visitorItem}
                trigger={
                    <div className="visitor-item__clickable">
                        <span
                            className={`visitor-item__name${hasBadges ? '' : ' visitor-item__name--solo'}`}
                            style={{ textDecoration: visitorItem.completed ? 'line-through' : 'none' }}
                        >
                            {visitorItem.visitor_first_name} {visitorItem.visitor_last_name}
                        </span>
                        <div className="visitor-item__tags">
                            {visitorItem.visitor_is_minor && (
                                <span className="visitor-tag visitor-tag--minor">Minor</span>
                            )}
                            {visitorItem.person_is_guardian && (
                                <span className="visitor-tag visitor-tag--guardian">Guardian</span>
                            )}
                            {visitorItem.person_will_invite_others && (
                                <span className="visitor-tag visitor-tag--inviter">Inviter</span>
                            )}
                            {visitorItem.person_is_visitor && !visitorItem.visitor_is_minor && (
                                <span className="visitor-tag visitor-tag--visitor">Visitor</span>
                            )}
                            {visitorItem.visitor_is_minor && (
                                visitorItem.user_is_guardian
                                    ? <span className="visitor-tag visitor-tag--guardian">
                                        {[visitorItem.guardian_first_name, visitorItem.guardian_last_name]
                                            .filter(Boolean).join(' ')}
                                      </span>
                                    : visitorItem.guardian_id && !visitorItem.guardian_missing
                                        ? <span className="visitor-tag visitor-tag--guardian">
                                            {[visitorItem.guardian_first_name, visitorItem.guardian_last_name]
                                                .filter(Boolean).join(' ')}
                                          </span>
                                        : <span className="visitor-tag visitor-tag--warning">Needs Guardian</span>
                            )}
                        </div>
                    </div>
                }
            />
            <div className="visitor-item__actions">
                <ShowPopup item={visitorItem} />
                <DeletePopup id={visitorItem.id} />
            </div>
        </li>
    )
}
